import * as React from "react";
import { User } from "../../api";
const context = React.createContext<User>(undefined as unknown as User)
export const UserContextProvider = context.Provider
export const UserContextConsumer = context.Consumer


// WEBPACK FOOTER //
// ./src/components/context/user.ts